var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rotation-indicator",class:_vm.rootClasses,style:(_vm.rootStyles)},[_c('div',{staticClass:"rotation-indicator__label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }